import { doc, docx, pdf } from '../../../../services/fileTypes/CommonMimeTypes';

export const typeOfDocumentAvailableToSignList = [doc, docx, pdf];
